import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { lastValueFrom, Observable, of } from 'rxjs';

import { EidosApiService } from '@common/services/eidos-api.service';
import { EidosSecurityService } from '@common/services/eidos-security.service';
import { SpinnerOverlayService } from '@common/services/spinner-overlay.service';
import { EidosExternalAppService } from '@common/eidos-external-app/eidos-external-app.service';
import { EidosConfigService } from '../config/eidos-config.service';

@Injectable({
  providedIn: 'root'
})
export class EidosTokenGuard  {


  constructor(
    public router: Router
    , public eidosSecurityService: EidosSecurityService
    , public externalAppService: EidosExternalAppService
    , public spinnerOverlayService: SpinnerOverlayService
    , public eidosApiService: EidosApiService
    , public eidosConfigService: EidosConfigService
  ) {
  }

  protected amIAuthenticated(): Observable<boolean | UrlTree> {
    const grantAccess = this.eidosSecurityService.amIAuthenticated();
    if (!grantAccess) {
      return this.eidosApiService.amIAuthenticated();
    } else {
      return of(true);
    }
  }

  canActivate(_route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    return new Promise<boolean | UrlTree>(resolve => {
      lastValueFrom(this.amIAuthenticated()).then(authenticated => {
        if (authenticated === true) {
          resolve(true);
          return;
        }

        this.redirectToLogin();
        // Always resolve so the router does not hang on a blank page if navigation is delayed
        resolve(false);
      }).catch(() => {
        this.redirectToLogin();
        resolve(false);
      });
    });
  }

  private redirectToLogin(): void {
    const cfg = this.eidosConfigService.currentConfig.getValue();
    const reqRoute = window.location.href
      .replace(cfg?.moduleBaseUrl?.eidos ?? '', '')
      .replace(cfg?.moduleBaseUrl?.reservation ?? '', '')
      .replace(cfg?.moduleBaseUrl?.resAdmin ?? '', '');

    // Persist return URL before clearAuthentication triggers the hard redirect
    this.eidosSecurityService.setRequestedRoute(reqRoute);
    this.eidosSecurityService.clearAuthentication();
  }
}
